import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import mutations from './mutations'
import getters from './getters'
// Home
import Homepage from '@/Homepage/store'
// Auth
import Auth from '@/Auth/store'
// Validation
import Validation from '@/Validation/store'

// Product
import Product from '@/Product/store'
// Package
import Package from '@/Package/store'
// Shop
import Shop from '@/Shop/store'
// Cart
import Cart from '@/Cart/store'
// Account
import Account from '@/Account/store'
// Payment
import Payment from '@/Payment/store'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production'

export const store = new Vuex.Store({
  modules: {
    Auth,
    Validation,
    Homepage,
    Product,
    Package,
    Cart,
    Account,
    Payment,
    Shop,
  },
  state: {
    role: '',
    permissionLevel: '',
    routeStatus:{},
    imageDomain: 'https://www.kolpartner.cn/kol-rest',
    hideFooter: false,
    shippingFee:28,
    noShippingFee:0,
    shippingMethod: ['S'],
    exchangeRate: 1,
    tariffRate: 0.112,
    discountRate: 0.15,
    currency: 'CNY',
    addressList: [],
    cartProducts:[],
    cartPackages:[],
    currentAddress: {},
    currentUser:{"ID":0, "username": "abc"},
    searchParam:{
      search:'',
      categoryID:'0',
    },
    currentTab:0,
    currentTxn: {list:[], total:0},
    shouldRefresh: true,
    currentPages: 10,
    refresh: false,
  },
  strict: debug,
  actions,
  mutations,
  getters

})



// WEBPACK FOOTER //
// ./src/store/index.js